import { useFormState as useFinalFormState } from 'react-final-form'

export function useUpdateFormProducts({ form }) {
  const formState = useFinalFormState();

  const updateProduct = (productId, productData) => {
    form.change("products", formState.values.products?.map(p => p?.id === productId ? { ...p, ...productData } : p) ?? []);
  };

  const addProduct = (product) => {
    form.change("products", [
      ...(formState.values.products ?? []),
      {
        ...product,
      }
    ]);
  };

  const removeProduct = (productId) => {
    form.change("products", formState.values.products?.filter(p => p?.id !== productId) ?? []);
  };

  const productExists = (productId) => {
    return formState.values.products?.some(p => p?.id === productId) ?? false;
  }

  const getProductFieldIndex = (productId) => {
    return formState.values.products?.findIndex(p => p?.id === productId);
  }

  return {
    updateProduct,
    addProduct,
    removeProduct,
    productExists,
    getProductFieldIndex,
  }
}